import { Radio } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const CustomOption = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <Radio label={children} checked={props.isSelected} />
    </components.Option>
  );
};

CustomOption.propTypes = {
  children: PropTypes.node,
  props: PropTypes.shape({
    isSelected: PropTypes.bool
  })
};

export { CustomOption };
